import React from 'react';
import { Breadcrumbs } from '@mui/material';
import Link from 'next/link';
import s from './styles.module.scss';
import classNames from 'classnames';

export interface IBreadcrumb {
  title: string;
  path: string;
}

const Breadcrumb: React.FC<IBreadcrumb> = ({ title, path }) => {
  return (
    <Link
      prefetch={false}
      href={path}
      passHref
      className={s['breadcrumb']}
      dir="auto"
    >
      {title}
    </Link>
  );
};

interface IAppBreadcrumbsProps {
  links: IBreadcrumb[];
}

const AppBreadcrumbs: React.FC<IAppBreadcrumbsProps> = (props) => {
  const { links } = props;

  const inactiveBreadcrumbClassNames = classNames(
    s['breadcrumb'],
    s['inactive']
  );

  return (
    <Breadcrumbs
      sx={{
        textTransform: 'capitalize',
        fontSize: '14px',
        lineHeight: '13px',
        letterSpacing: '-0.154px',
        margin: '0',
      }}
    >
      {links.map((link, index) =>
        links.length !== index + 1 ? (
          <Breadcrumb key={index} title={link.title} path={link.path} />
        ) : (
          <span key={index} className={inactiveBreadcrumbClassNames}>
            {link.title}
          </span>
        )
      )}
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
